import { UserOutlined } from "@ant-design/icons";
import { Evidence } from "@p0security/shared/types/evidence";
import { Typography } from "@p0security/ui";
import { formatDistanceStrict } from "date-fns";
import React from "react";

import { ApprovalSourceIcon } from "./ApprovalSourceIcon";
import { IconWithBadge } from "./IconWithBadge";
import { UserCell } from "./UserCell";

export const ApproverCell: React.FC<{
  approvalSource: string;
  timestamp?: number;
  username?: string;
  preApproval?: readonly [Evidence["source"], string] | "unknown";
}> = ({ approvalSource, timestamp, username, preApproval }) => {
  if (!username) return null;

  return (
    <UserCell
      icon={
        <IconWithBadge
          icon={<UserOutlined />}
          badge={<ApprovalSourceIcon source={approvalSource} />}
          tooltip={`Approved via ${approvalSource}`}
        />
      }
      username={username}
      subtitle={
        timestamp != null ? (
          <Typography.Text className="sub-text" ellipsis type="secondary">
            {formatDistanceStrict(timestamp, Date.now(), {
              addSuffix: true,
            })}
          </Typography.Text>
        ) : undefined
      }
      preApproval={preApproval}
    />
  );
};
